import React, { useState } from "react";
import { withStyles, Typography } from "@material-ui/core";
import Pagination from "@jll/pagination";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const MIN_PAGE_SIZE = 10;
const MAX_PAGE_SIZE = 500;

const PaginationComponent = (props) => {
  const {
    handleRowsPerPage,
    totalItemsCount,
    handlePagination,
    rowsPerPage,
    pageNumber,
    classes,
  } = props;
  const [pageSize, setPageSize] = useState();
  const [error, setError] = useState();
  const { t } = useTranslation();

  const handleRowChange = (e) => {
    if (Number(e.target.value > MAX_PAGE_SIZE) || Number(e.target.value < MIN_PAGE_SIZE)) {
      setError(true);
    } else if (Number(e.target.value) !== rowsPerPage) {
      setError(false);
      handleRowsPerPage(Number(e.target.value));
    }
  };

  return (
    <div className={classes.tablePagination}>
      <Typography style={{ fontSize: 13 }}>
        <input
          type="number"
          style={{ width: 50, marginRight: 10 }}
          value={pageSize ? pageSize : rowsPerPage}
          onChange={(e) => setPageSize(e.target.value)}
          onBlur={(e) => handleRowChange(e)}
        />
        {t("labels.common.pagination.recordsPerPage")} (
          {t("labels.common.pagination.totalRecords", { totalItemsCount: totalItemsCount })}
        )
      </Typography>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          totalItemsCount={totalItemsCount}
          itemsCountPerPage={rowsPerPage}
          pageRangeDisplayed={5}
          onChange={handlePagination}
          activePage={pageNumber}
        />
      </div>
      {error && (
        <span className={classes.errorText}>
          {t("messages.pagination.rowPerPageError", { minPageSize: MIN_PAGE_SIZE, maxPageSize: MAX_PAGE_SIZE })}
        </span>
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PaginationComponent);
